export const report_editable_index = ['report_editable.index']
export const report_editable_edit = ['report_editable.edit']

export default [].concat(
    report_editable_index,
    report_editable_edit
)
